export default __webpack_public_path__ + "static/media/flag-nl-BE.3fa23a6a.png";